import { ReactComponent as spinnerPrimary } from './variants/spinner-primary.svg';
import { ReactComponent as spinnerNeutral } from './variants/spinner-neutral.svg';

const SpinnerSource = {
  primary: spinnerPrimary,
  neutral: spinnerNeutral,
};

export default SpinnerSource;
